import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const usePersistedSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchInput, setSearchInput] = useState(() => searchParams.get('search') || '')

  useEffect(() => {
    setSearchParams(
      (searchParams) => {
        if (searchInput === '') {
          searchParams.delete('search')
        } else {
          searchParams.set('search', searchInput)
        }
        return searchParams
      },
      { replace: true },
    )
  }, [searchInput])

  return { searchInput, setSearchInput }
}
